import App from '@/models/App'

export default class ChatMessage extends App {
    static get entity() {
        return 'ChatMessages'
    }
    static fields() {
        return {
            id: this.attr(''),
            chatRoomId: this.attr(''),
            userId: this.attr(''),
            userName: this.attr(''),
            companyName: this.attr(''),
            userImage: this.attr(''),
            body: this.attr(''),
            documentId: this.attr(''),
            createdAt: this.attr(''),
            updatedAt: this.attr(''),
            isEdited: this.attr(''),
            isSent: this.attr(''),
            isRead: this.attr(''),
            chatDocument: this.attr(''),
        }
    }
    static getByChatRoomId(chatRoomId) {
        const messages = this.query()
            .withAllRecursive()
            .where('chatRoomId', chatRoomId)
            .get()
        return messages.sort((a, b) => {
            return a.createdAt > b.createdAt ? 1 : -1
        })
    }
    static all() {
        return this.query().withAllRecursive().get()
    }
    static apiConfig = {
        actions: {
            fetch(chatRoomId, page) {
                return this.get(`/${chatRoomId}/chats/messages?page=${page}`, {
                    params: {},
                    headers: {
                        Authorization: 'Bearer ' + App.apiToken(),
                        'Accept-Language': App.acceptLanguage(),
                    },
                    dataKey: 'data',
                    baseURL: App.overallURL(),
                })
            },
            create(chatRoomId, params) {
                return this.post(
                    `/${chatRoomId}/chats/messages`,
                    App.post(params),
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        dataKey: 'data',
                        baseURL: App.overallURL(),
                    }
                )
            },
            update(chatRoomId, chatMessageId, params) {
                return this.patch(
                    `${chatRoomId}/chats/messages/${chatMessageId}`,
                    App.patch(params),
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        dataKey: 'data',
                        baseURL: App.overallURL(),
                    }
                )
            },
            destroy(chatRoomId, chatMessageId) {
                return this.delete(
                    `${chatRoomId}/chats/messages/${chatMessageId}`,
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        delete: 'data',
                        baseURL: App.overallURL(),
                    }
                )
            },
        },
    }
}
